module.exports = __webpack_public_path__ + "static/media/datepicker-next-nav.f1a586ae.svg";